import styled from './modalwats.module.css'
import { useContext, useEffect, useState } from 'react';
import {AuthContext} from '../../services/global';
import api from '../../services/api';
import {Alerta} from '../../utils/functions';
import InputMask from 'react-input-mask';

function ModalWats() {
    const {setIsOpenW} = useContext(AuthContext);
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    const { numwats } = useContext(AuthContext);


    const [wats,setWats] = useState(numwats);
    
    function closeModal() {
        setIsOpenW(false);
    }

    async function PutWats(){
        await api.post(`info/wats?numwats=${wats}&cgccli=${cgccli}`)
        .then((response)=>{
             if(!response.data.errocod){
                 closeModal();
                 
                 Alerta('Sucesso','Alteração realizada com sucesso!','success');
             }else{
                closeModal(); 
                Alerta('Erro',response.data.errocod,'error')
             }
        }).catch((erro)=>{
            closeModal();
            Alerta('Erro',erro,'error')
        })
    }

    useEffect(()=>{
        
    },[])

     



    return (

            <div className={styled.modal}>
                <div className={styled.modalheader}>
                    <a>Atualizar WhatsApp</a>
                    <div className={styled.cardtitleline}></div>
                </div>
                <div className={styled.modalcontent}>
                    <div className={styled.appmodal}>
                        <div className={styled.div1}>
                            <a>WhatsApp</a>
                            <InputMask mask="(99)99999-9999" value={wats} onChange={(e)=>setWats(e.target.value)}></InputMask>
                        </div>
                    </div>

                </div>
                <div className={styled.modalfooter} onClick={()=>PutWats()}>
                    SALVAR
                </div>
            </div>
    )
}

export default ModalWats;